import { ActionTypes } from "@/App/constants/actionTypes";
import { PricingLevelsTypes } from "@/types";
import { NavigateFunction } from "react-router";

type CreatePricingLevelAction = {
  type: typeof ActionTypes.CREATE_PRICING_LEVEL;
  payload: PricingLevelsTypes.PricingLevel;
  formName: string;
  navigate: NavigateFunction;
};

export const createPricingLevel = (
  payload: PricingLevelsTypes.PricingLevel,
  formName: string,
  navigate: NavigateFunction,
): CreatePricingLevelAction => {
  return {
    type: ActionTypes.CREATE_PRICING_LEVEL,
    payload,
    formName,
    navigate,
  };
};

type CreatePricingLevelResultsAction = {
  type: typeof ActionTypes.CREATE_PRICING_LEVEL_RESULTS;
  payload: PricingLevelsTypes.PricingLevel;
  navigate: NavigateFunction;
};

export const createPricingLevelResults = (data: PricingLevelsTypes.PricingLevel, navigate: NavigateFunction): CreatePricingLevelResultsAction => {
  return {
    type: ActionTypes.CREATE_PRICING_LEVEL_RESULTS,
    payload: data,
    navigate,
  };
};

export type CreatePricingLevelActions = CreatePricingLevelAction | CreatePricingLevelResultsAction;
